/**
 * Shared socket.io-client options for DeviceCard, Dashboard, etc.
 *
 * `transports: ['polling', 'websocket']` — Engine.IO handshakes with HTTP long-polling
 * first, then upgrades. If WebSocket is dropped, reconnect can fall back to polling
 * (important on mobile / restrictive networks and to avoid 503s from reconnect storms).
 * `rememberUpgrade: false` — on reconnect, transport choice is re-evaluated so a bad WS
 * path does not get stuck.
 * Reconnect delays: avoid hammering the server (and Heroku router) on flaky mobile links.
 */
export function getSocketIoServerUrl() {
  return process.env.REACT_APP_API_URL || undefined;
}

export const SOCKET_IO_CLIENT_OPTIONS = {
  path: '/socket.io',
  transports: ['polling', 'websocket'],
  rememberUpgrade: false,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 5_000,
  reconnectionDelayMax: 10_000,
  timeout: 20_000,
  autoConnect: true,
  forceNew: false,
};
